import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import {DISABLE_MODAL_RETRIES, APIVERSION} from '../../RequestManagerConstants';

class ListNpvrFromUrlTask extends AbstractRequestTask {
  constructor(params,url) {
    super();

    this.params = params;
    this.url=url;
  }

  getUrl() {
    if(this.url){
      const http = "https://";
      const url = Launcher.get("akamai_mfwk");
      return `${http}${url}${this.url}`;
    }

    else {
      const http = "https://";
      const url = Launcher.get("akamai_mfwk");
      return `${http}${url}/services/recordings/v1/list`;
    }
  }

  getParams() {
    const params = super.getParams();
    delete params.HKS;
    delete params.api_version;
    if(this.url && !this.url.includes('/v1/')) {
      params.api_version = APIVERSION;
    }
    return Object.assign({}, params, this.params);
  }

  getShowErrorModal(){
    return DISABLE_MODAL_RETRIES;
  }

  getShowModal() {
    return false;
  }
}

export default ListNpvrFromUrlTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/npvr/ListNpvrFromUrlTask.js